import { useCallback } from 'react';

import {
  EAccessCheckTrackingStatus,
  ESubscriptionLimitType,
  useEarlyAccessPaywallContext,
} from '@/packages/EarlyAccessPaywall';
import { useIsUserAuthenticatedQuery } from '@/packages/query-state/shared/store/monolith-python/cian-api/site/v1/get-user-data-by-request/query';

import { useCardOfferId } from '../../context/selectors';

interface ICallbacks {
  onConfirmed: VoidFunction;
  onBlocked: (trackingStatus: EAccessCheckTrackingStatus) => void;
}

/**
 * @description
 * Хук для создания хелпера для обработки флоу раннего доступа
 * @param tracking - объект с трекингом флоу раннего доступа
 */
export const useEarlyAccessFlow = ({ onConfirmed, onBlocked }: ICallbacks): (() => Promise<void>) => {
  const isAuthenticated = useIsUserAuthenticatedQuery();
  const { checkContactsAccess } = useEarlyAccessPaywallContext();
  const offerId = useCardOfferId();

  return useCallback(async (): Promise<void> => {
    if (!isAuthenticated) {
      onBlocked(EAccessCheckTrackingStatus.Unauthorized);
    }

    const { isConfirmed, trackingStatus } = await checkContactsAccess({
      offerId,
      limitType: ESubscriptionLimitType.PhoneNumber,
    });

    if (isConfirmed) {
      onConfirmed();
    } else if (trackingStatus) {
      onBlocked(trackingStatus);
    }
  }, [checkContactsAccess, isAuthenticated, offerId, onBlocked, onConfirmed]);
};
